import { useSearchParams } from 'react-router-dom';
import { ProductList } from './products/ProductList';
import { BundleList } from './bundles/BundleList';
import { SafetyRuleList } from './safety/SafetyRuleList';

type TabId = 'products' | 'bundles' | 'safety';

const TABS: { id: TabId; label: string }[] = [
  { id: 'products', label: 'Products' },
  { id: 'bundles', label: 'Bundles' },
  { id: 'safety', label: 'Safety Rules' },
];

const VALID_TABS = new Set<string>(TABS.map((t) => t.id));

export function FormularyTabView() {
  const [searchParams, setSearchParams] = useSearchParams();
  const rawTab = searchParams.get('tab') || '';
  const activeTab: TabId = VALID_TABS.has(rawTab) ? (rawTab as TabId) : 'products';

  const setActiveTab = (tab: TabId) => {
    if (tab === 'products') {
      setSearchParams({});
    } else {
      setSearchParams({ tab });
    }
  };

  return (
    <div>
      {/* Tab bar — matches FinancialDashboard pattern */}
      <div className="flex gap-1 border-b border-bg-tertiary mb-6 pb-1 overflow-x-auto">
        {TABS.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`px-4 py-2 text-base font-medium whitespace-nowrap transition-colors ${
              activeTab === tab.id
                ? 'text-gold border-b-2 border-gold'
                : 'text-text-secondary hover:text-text-primary'
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {activeTab === 'products' && <ProductList />}
      {activeTab === 'bundles' && <BundleList />}
      {activeTab === 'safety' && <SafetyRuleList />}
    </div>
  );
}
